export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productType/state.js